module.exports = __webpack_public_path__ + "assets/img/Collected.f2f80787.png";